import React from 'react'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export interface QueryOrder {
    orderBy: string;
    orderDir: 'asc' | 'desc';
}

type Props = {
    children?: React.ReactNode;
    className?: string;
    align?: 'left' | 'center' | 'right';
    showOrderIcon?: boolean;
    orderKey?: string;
    order?: QueryOrder | null;
    setOrder?: (orderBy: QueryOrder | null) => void;
}

const TableHeadCell = (props: Props) => {
    const orderActive = props.order != null && props.order.orderBy === props.orderKey;
    function alignClassName() {
        if (props.align === 'left') {
            return 'text-left'
        }
        if (props.align === 'center') {
            return 'text-center'
        }
        if (props.align === 'right') {
            return 'text-right';
        }
        return 'text-left';
    }

    function orderButtonClassName() {
        if (orderActive) {
            return "bg-primary-dark text-white";
        }
        return "bg-transparent opacity-30 hover:opacity-80"
    }

    function onOrderIconClick() {
        if (!props.setOrder || !props.orderKey) {
            return;
        }
        if (orderActive) {
            if (props.order?.orderDir === 'asc') {
                props.setOrder({ orderBy: props.orderKey, orderDir: 'desc' });
            } else {
                props.setOrder(null);
            }
        } else {
            props.setOrder({ orderBy: props.orderKey, orderDir: 'asc' });
        }
    }

    function cursorsClassName() {
        if (props.setOrder && props.orderKey) {
            return "cursor-pointer";
        }
        return "";
    }

    return (
        <th className={`${cursorsClassName()} px-2 align-middle border-solid border-[1px] border-primary border-opacity-20 ${props.className}`} onClick={onOrderIconClick}>
            <div
                className={`flex gap-1`}
            >
                <div className={`${alignClassName()} align-middle flex-grow`}>
                    {props.children}
                </div>
                {props.showOrderIcon && (
                    <div>
                        <button
                            className={`w-[28px] h-[28px] rounded-[8px] flex items-center justify-center ${orderButtonClassName()}`}>
                            {!orderActive && <ArrowUpwardIcon style={{ fontSize: "20px" }} />}
                            {orderActive && props.order?.orderDir === "asc" && <ArrowUpwardIcon style={{ fontSize: "20px" }} />}
                            {orderActive && props.order?.orderDir === "desc" && <ArrowDownwardIcon style={{ fontSize: "20px" }} />}
                        </button>
                    </div>
                )}
            </div>
        </th>
    )
}

export default TableHeadCell